/* eslint-disable */
import {
  Autocomplete,
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  IconButton,
  Paper,
  TextField,
  Tooltip,
} from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import CloseIcon from "@mui/icons-material/Close";
import { useEffect, useState } from "react";
import MUIDataTable from "mui-datatables";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import { getDepartamentos } from "../../../services/ParametrosService";

const initialState = {
  tipo: "",
  calle: "",
  numero_calle: "",
  descripcion: "",
  codigo_postal: "",
  piso: "",
  dpto: "",
  monoblock: "",
  barrio: "",
  manzana: "",
  casa: "",
  localidad: "",
  coordenadas: "",
  id: "",
  id_departamento: "",
  id_provincia: "",
  id_pais: "",
  domicilio_electronico: "",
  domicilio_contractual: "",
  latitud: "",
  longitud: ""
};

const tableColumns = (handleObtienedomicilio) => [
  {
    name: "id",
    label: "ID",
    options: {
      filter: false,
      sort: false,
      display: "excluded",
    },
  },
  {
    name: "tipo",
    label: "Tipo de domicilio",
    options: {
      filter: false,
      sort: false,
    },
    setCellProps: () => ({
      style: {
        textAlign: 'center',
      },
    }),
    setCellHeaderProps: () => ({
      style: {
        textAlign: 'center',
      },
    }),
  },
  {
    name: "actions",
    label: "Acciones",
    options: {
      filter: false,
      sort: false,
      empty: true,
      setCellProps: () => ({
        style: {
          textAlign: 'center',
        },
      }),
      setCellHeaderProps: () => ({
        style: {
          textAlign: 'center',
        },
      }),
      customBodyRenderLite: (dataIndex) => (
        <>
          <Tooltip title="Ver Domicilio">
            <IconButton
              size="small"
              aria-label="view"
              onClick={() => handleObtienedomicilio(dataIndex)}
            >
              <RemoveRedEyeOutlinedIcon />
            </IconButton>
          </Tooltip>
        </>
      ),
    },
  },
];

const tableOptions = {
  download: false,
  filter: false,
  print: false,
  search: false,
  viewColumns: false,
  pagination: false,
  elevation: 1,
  selectableRows: "none",
  textLabels: {
    body: {
      noMatch: "No se encontraron registros",
    },
  },
};

const nameItemText = "Domicilios";
const itemGender = "M";

const DomiciliosDialog = ({
  onSave,
  onClose,
  itemCrud,
  itemsCrud,
  actionCrud,
  setMessage,
  setShowMessage
}) => {
  const [itemCrudLocal, setItemCrudLocal] = useState(initialState);
  const [domicilios, setDomicilios] = useState([]);
  const [departamentos, setDepartamentos] = useState([]);
  const [provincias, setProvincias] = useState([]);
  const [paises, setPaises] = useState([]);

  useEffect(() => {
    loadDepartamentos();
    if (actionCrud === "create") {
      setItemCrudLocal(initialState);
    } else {
      setItemCrudLocal(itemCrud);
    }
    let _itemCrud = itemCrud;
    _itemCrud = itemCrud
    if (_itemCrud.length > 0) {
      _itemCrud.forEach((item) => {
        item.tipo = item.tipo.toUpperCase();
      });
    }
    setDomicilios(_itemCrud);
  }, [actionCrud, itemCrud, itemsCrud]);




  const handleObtienedomicilio = (dataIndex) => {
    const selectedDomicilio = domicilios[dataIndex];
    setItemCrudLocal({
      tipo: selectedDomicilio.tipo,
      numero_calle: selectedDomicilio.numero_calle,
      calle: selectedDomicilio.calle ? (selectedDomicilio.calle).toUpperCase() : "",
      descripcion: selectedDomicilio.descripcion ? (selectedDomicilio.descripcion).toUpperCase() : "",
      codigo_postal: selectedDomicilio.codigo_postal,
      piso: selectedDomicilio.piso,
      dpto: selectedDomicilio.dpto ? (selectedDomicilio.dpto).toUpperCase() : "",
      monoblock: selectedDomicilio.monoblock ? (selectedDomicilio.monoblock).toUpperCase() : "",
      barrio: selectedDomicilio.barrio ? (selectedDomicilio.barrio).toUpperCase() : "",
      manzana: selectedDomicilio.manzana ? (selectedDomicilio.manzana).toUpperCase() : "",
      casa: selectedDomicilio.casa ? (selectedDomicilio.casa).toUpperCase() : "",
      localidad: selectedDomicilio.localidad ? (selectedDomicilio.localidad).toUpperCase() : "",
      coordenadas: selectedDomicilio.coordenadas,
      id: selectedDomicilio.id,
      id_departamento: selectedDomicilio.departamento ? (selectedDomicilio.departamento).toUpperCase() : "",
      id_provincia: selectedDomicilio.provincia ? (selectedDomicilio.provincia).toUpperCase() : "",
      id_pais: selectedDomicilio.pais ? (selectedDomicilio.pais).toUpperCase() : "",
      domicilio_electronico: selectedDomicilio.domicilio_electronico,
      domicilio_contractual: selectedDomicilio.domicilio_contractual,
      latitud: selectedDomicilio.latitud,
      longitud: selectedDomicilio.longitud,

    });
  };

  const handleCloseDialog = () => {
    onClose();
  };

  const handleChange = (e) => {
    setItemCrudLocal({
      ...itemCrudLocal,
      [e.target.name]:
        e.target.type === "checkbox" ? e.target.checked : e.target.value,
    });
  };

  const handleSave = () => {
    if (itemCrudLocal.tipo === "" || itemCrudLocal.numero === "") {
      setMessage({
        severity: "error",
        messageText: "Debes completar todos los campos.",
      });
      setShowMessage(true);
      return;
    }
    save();
  };

  const save = async () => {
    const _itemCrud = {
      tipo: itemCrudLocal.tipo,
      numero_calle: itemCrudLocal.numero_calle,
      calle: itemCrudLocal.calle,
      descripcion: itemCrudLocal.descripcion,
      codigo_postal: itemCrudLocal.codigo_postal,
      piso: itemCrudLocal.piso,
      dpto: itemCrudLocal.dpto,
      monoblock: itemCrudLocal.monoblock,
      barrio: itemCrudLocal.barrio,
      manzana: itemCrudLocal.manzana,
      casa: itemCrudLocal.casa,
      localidad: itemCrudLocal.localidad,
      coordenadas: itemCrudLocal.coordenadas,
      id: itemCrudLocal.id,
      id_departamento: itemCrudLocal.id_departamento,
      id_provincia: itemCrudLocal.id_provincia,
      id_pais: itemCrudLocal.id_pais,
      domicilio_electronico: itemCrudLocal.domicilio_electronico,
      domicilio_contractual: itemCrudLocal.domicilio_contractual,
      latitud: itemCrudLocal.latitud,
      longitud: itemCrudLocal.longitud,

    };


    if (response.ok) {
      onSave();
    }

    setMessage({
      messageText: response.messageText,
      severity: response.messageSeverity,
    });
    setShowMessage(true);
  };

  // Obtener departamentos
  const loadDepartamentos = async () => {
    const response = await getDepartamentos();
    console.log('TODO Delete');
    console.log('loadDepartamentos - response: ', response);
    console.log('##################');
    if (response.ok) {
      setDepartamentos(response.departamentos);

    }
  }




  return (
    <Dialog
      open={true}
      onClose={handleCloseDialog}
      maxWidth="lg"
      fullWidth={true}
      scroll="paper"
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle id="form-dialog-title">
        {actionCrud === "view" ? "Ver" : "Nuevo"} {nameItemText}
        <IconButton
          aria-label="close"
          onClick={handleCloseDialog}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '20vh',
            mb: 2,
          }}
        >
          <Paper
            elevation={3}
            sx={{
              p: 3,
              maxWidth: '1200px',
              width: '100%',
              m: 'auto',
              boxSizing: 'border-box',
            }}
          >
            <Grid container spacing={2}>

              <Grid item xs={12} md={6} lg={2}>
                <FormControl fullWidth sx={{ mb: 1 }}>
                  <Autocomplete
                    id="tipo"
                    options={domicilios ? domicilios.map((doc) => doc.tipo) : []}
                    value={itemCrudLocal.tipo || null}
                    onChange={(event, newValue) => {
                      handleChange({
                        target: {
                          name: "tipo",
                          value: newValue || "",
                        },
                      });
                    }}
                    disabled={actionCrud === "view"}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Tipo de domicilio"
                        size="small"
                      />
                    )}
                    ListboxProps={{ style: { maxHeight: "300px" } }}
                  />
                </FormControl>
              </Grid>


              <Grid item xs={12} md={12} lg={6}>
                <TextField
                  fullWidth
                  sx={{ mb: 1 }}
                  inputProps={{
                    autoComplete: "off",
                    readOnly: actionCrud === 'view'
                  }}
                  id="calle"
                  label="Calle"
                  variant="outlined"
                  size="small"
                  name="calle"
                  value={itemCrudLocal.calle}
                  onChange={handleChange}
                />
              </Grid>

              <Grid item xs={12} md={4} lg={2}>
                <TextField
                  fullWidth
                  sx={{ mb: 1 }}
                  inputProps={{
                    autoComplete: "off",
                    readOnly: actionCrud === 'view'
                  }}
                  id="numero_calle"
                  label="N° de calle"
                  variant="outlined"
                  size="small"
                  name="numero_calle"
                  value={itemCrudLocal.numero_calle}
                  onChange={handleChange}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={6}>
                <TextField
                  fullWidth
                  sx={{ mb: 1 }}
                  inputProps={{
                    autoComplete: "off",
                    readOnly: actionCrud === 'view'
                  }}
                  id="descripcion"
                  label="Descripción"
                  variant="outlined"
                  size="small"
                  name="descripcion"
                  value={itemCrudLocal.descripcion === 'SIN DATOS DE DOMICILIO' ? "" : itemCrudLocal.descripcion}
                  onChange={handleChange}
                />
              </Grid>



              <Grid item xs={12} md={4} lg={2}>
                <TextField
                  fullWidth
                  sx={{ mb: 1 }}
                  inputProps={{
                    autoComplete: "off",
                    readOnly: actionCrud === 'view'
                  }}
                  id="piso"
                  label="Piso"
                  variant="outlined"
                  size="small"
                  name="piso"
                  value={itemCrudLocal.piso}
                  onChange={handleChange}
                />
              </Grid>

              <Grid item xs={12} md={4} lg={2}>
                <TextField
                  fullWidth
                  sx={{ mb: 1 }}
                  inputProps={{
                    autoComplete: "off",
                    readOnly: actionCrud === 'view'
                  }}
                  id="dpto"
                  label="Dpto"
                  variant="outlined"
                  size="small"
                  name="dpto"
                  value={itemCrudLocal.dpto}
                  onChange={handleChange}
                />
              </Grid>

              <Grid item xs={12} md={4} lg={2}>
                <TextField
                  fullWidth
                  sx={{ mb: 1 }}
                  inputProps={{
                    autoComplete: "off",
                    readOnly: actionCrud === 'view'
                  }}
                  id="monoblock"
                  label="Monoblock"
                  variant="outlined"
                  size="small"
                  name="monoblock"
                  value={itemCrudLocal.monoblock}
                  onChange={handleChange}
                />
              </Grid>



              <Grid item xs={12} md={4} lg={2}>
                <TextField
                  fullWidth
                  sx={{ mb: 1 }}
                  inputProps={{
                    autoComplete: "off",
                    readOnly: actionCrud === 'view'
                  }}
                  id="manzana"
                  label="Manzana"
                  variant="outlined"
                  size="small"
                  name="manzana"
                  value={itemCrudLocal.manzana}
                  onChange={handleChange}
                />
              </Grid>

              <Grid item xs={12} md={4} lg={2}>
                <TextField
                  fullWidth
                  sx={{ mb: 1 }}
                  inputProps={{
                    autoComplete: "off",
                    readOnly: actionCrud === 'view'
                  }}
                  id="casa"
                  label="Casa"
                  variant="outlined"
                  size="small"
                  name="casa"
                  value={itemCrudLocal.casa}
                  onChange={handleChange}
                />
              </Grid>

              <Grid item xs={12} md={6} lg={4}>
                <TextField
                  fullWidth
                  sx={{ mb: 1 }}
                  inputProps={{
                    autoComplete: "off",
                    readOnly: actionCrud === 'view'
                  }}
                  id="barrio"
                  label="Barrio"
                  variant="outlined"
                  size="small"
                  name="barrio"
                  value={itemCrudLocal.barrio}
                  onChange={handleChange}
                />
              </Grid>

              <Grid item xs={12} md={6} lg={4}>
                <TextField
                  fullWidth
                  sx={{ mb: 1 }}
                  inputProps={{
                    autoComplete: "off",
                    readOnly: actionCrud === 'view'
                  }}
                  id="localidad"
                  label="Localidad"
                  variant="outlined"
                  size="small"
                  name="localidad"
                  value={itemCrudLocal.localidad}
                  onChange={handleChange}
                />
              </Grid>

              <Grid item xs={12} md={6} lg={4}>
                <FormControl fullWidth sx={{ mb: 1 }}>
                  <Autocomplete
                    id="id_departamento"
                    options={departamentos ? departamentos.map((dep) => dep.nombre) : []}
                    value={itemCrudLocal.id_departamento || null}
                    onChange={(event, newValue) => {
                      handleChange({
                        target: {
                          name: "id_departamento",
                          value: newValue || "",
                        },
                      });
                    }}
                    disabled={actionCrud === "view"}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Departamento"
                        size="small"
                      />
                    )}
                    ListboxProps={{ style: { maxHeight: "300px" } }}
                  />
                </FormControl>
              </Grid>


              <Grid item xs={12} md={6} lg={4}>
                <FormControl fullWidth sx={{ mb: 1 }}>
                  <Autocomplete
                    id="id_provincia"
                    options={provincias ? provincias.map((prov) => prov.nombre) : []}
                    value={itemCrudLocal.id_provincia || null}
                    onChange={(event, newValue) => {
                      handleChange({
                        target: {
                          name: "id_provincia",
                          value: newValue || "",
                        },
                      });
                    }}
                    disabled={actionCrud === "view"}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Provincia"
                        size="small"
                      />
                    )}
                    ListboxProps={{ style: { maxHeight: "300px" } }}
                  />
                </FormControl>
              </Grid>

              <Grid item xs={12} md={6} lg={4}>
                <FormControl fullWidth sx={{ mb: 1 }}>
                  <Autocomplete
                    id="id_pais"
                    options={paises ? paises.map((pa) => pa.nombre) : []}
                    value={itemCrudLocal.id_pais || null}
                    onChange={(event, newValue) => {
                      handleChange({
                        target: {
                          name: "id_pais",
                          value: newValue || "",
                        },
                      });
                    }}
                    disabled={actionCrud === "view"}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="País"
                        size="small"
                      />
                    )}
                    ListboxProps={{ style: { maxHeight: "300px" } }}
                  />
                </FormControl>
              </Grid>

              <Grid item xs={12} md={4} lg={2}>
                <TextField
                  fullWidth
                  sx={{ mb: 1 }}
                  inputProps={{
                    autoComplete: "off",
                    readOnly: actionCrud === 'view'
                  }} id="codigo_postal"
                  label="Código postal"
                  variant="outlined"
                  size="small"
                  name="codigo_postal"
                  value={itemCrudLocal.codigo_postal}
                  onChange={handleChange}
                />
              </Grid>

            </Grid>
          </Paper>
        </Box>

        <MUIDataTable
          title={"Listado de domicilios"}
          columns={tableColumns(handleObtienedomicilio)}
          options={tableOptions}
          data={domicilios ? domicilios : []}
        />
        <Box sx={{ textAlign: "right", mb: 2, mt: 2 }}>
          {actionCrud !== "view" && (
            <Button
              sx={{ mr: 1 }}
              variant="contained"
              onClick={handleSave}
              startIcon={<SaveIcon />}
            >
              Guardar
            </Button>
          )}
          <Button sx={{ mr: 1 }} variant="outlined" onClick={handleCloseDialog}>
            {actionCrud === "view" ? "Volver" : "Cancelar"}
          </Button>
        </Box>
      </DialogContent>


    </Dialog>
  );
};

export default DomiciliosDialog;
